export type TCheckoutProps = {
  product?: ECheckoutProduct;
};

export enum ECheckoutProduct {
  CHECKOUT = 'Checkout.checkout',
  PRO = 'AstroPayPro.pro',
}
